import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const heap = defineConnector({
  identifier: "heap",
  name: "Heap",
  tagLine: "Product analytics platform",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://heapanalytics\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your Heap API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In Heap, go to **Account > Manage > Privacy & Security** to find your App ID, and **Account > Manage > Data** to generate an API key.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "App ID",
          required: true,
          target: { kind: "configuration", field: "appId" },
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://heapanalytics.com/api/partner/v1/account/info",
  },
});
